module.exports = __webpack_public_path__ + "img/brand_icon01.57eb35a.70df7725.png";